// extracted by mini-css-extract-plugin
export default {"main":"details_main__59fTq","detail":"details_detail__wm2UF"};